import { render, staticRenderFns } from "./CatastroUD.vue?vue&type=template&id=68211864&scoped=true&"
import script from "./CatastroUD.vue?vue&type=script&lang=js&"
export * from "./CatastroUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68211864",
  null
  
)

export default component.exports